import { FaAward } from 'react-icons/fa'


export const aboutMe= [
    {
        id: 1,
        icon : <FaAward className='about-icon' />,
        title : 'Experience',
        description : '3.6+ Years building scalable Node.js apps & microservices'
    },
    {
        id: 6,
        icon : <FaAward className='about-icon' />,
        title : 'Integrations',
        description : 'Stripe, Razorpay, Uber Eats, DoorDash, WhatsApp, AWS'
    },
    {
        id: 2,
        icon : <FaAward className='about-icon' />,
        title : 'Backend & DevOps',
        description : 'Node.js, Express, Docker, Redis, Elasticsearch'
    },
    {
        id: 3,
        icon : <FaAward className='about-icon' />,
        title : 'Architecture',
        description : 'Microservices, REST APIs, Event-driven systems'
    },

]
